import { useLocalObservable } from 'mobx-react-lite';
import { FormEvent, useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';

import { IDiscoverDestination } from 'APP/model/tenantRouter/tenantRouterModel.types';

export interface IDiscoverDestinationSelectorFormProps {
  onSubmit(destinationKey: string): void;
  destinations: IDiscoverDestination[];
}

interface IDiscoverDestinationSelectorFormPresenterParams
  extends IDiscoverDestinationSelectorFormProps {}

type TDestinationItem = {
  key: string;
  title?: string;
};

interface IDestinationSelectorFormFormData {
  destinationKey: string;
}

interface IDiscoverDestinationSelectorFormPresenter {
  destinations: IDiscoverDestination[];
  destinationItems: TDestinationItem[];
  setDestinations(destinations: IDiscoverDestination[]): void;
  onSubmit(e: FormEvent<HTMLFormElement>): void;
}

interface IUseIDiscoverDestinationSelectorFormPresenter {
  presenter: IDiscoverDestinationSelectorFormPresenter;
  form: UseFormReturn<IDestinationSelectorFormFormData>;
}

export function useDiscoverDestinationSelectorFormPresenter(
  params: IDiscoverDestinationSelectorFormPresenterParams
): IUseIDiscoverDestinationSelectorFormPresenter {
  const form = useForm<IDestinationSelectorFormFormData>({
    mode: 'onChange',
    defaultValues: {
      destinationKey: params.destinations[0]?.key || '',
    },
  });

  const presenter = useLocalObservable<IDiscoverDestinationSelectorFormPresenter>(() => ({
    destinations: params.destinations,

    get destinationItems(): TDestinationItem[] {
      return presenter.destinations.map((destination) => ({
        key: destination.key,
        title: destination.alias,
      }));
    },

    setDestinations(destinations: IDiscoverDestination[]): void {
      presenter.destinations = destinations;
    },

    onSubmit(e: FormEvent<HTMLFormElement>): void {
      form.handleSubmit((data) => params.onSubmit(data.destinationKey))(e);
    },
  }));

  useEffect(() => {
    presenter.setDestinations(params.destinations);
    form.setValue('destinationKey', params.destinations[0]?.key || '');
  }, [params.destinations]);

  return { presenter, form };
}
